import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Form, Col, Row } from "react-bootstrap";
import { useAuth } from "../../../context/AuthContext";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import { formatInputDate } from "../../../utils/Time";
import { autoDisplayValue } from "../../../commons/FormatValue";
import { getServiceRequest } from "../../../commons/ServiceRequest";
import {
  initializeSetOption,
  initializeSetOptionDisabled
} from "../../../utils/InitializeSetDefault";
import {
  FloatingControlComponent,
  SearchSelectComponent
} from "../../FormComponent";
import {
  emptyValueObjects,
  filteredItemInArray,
  findItemInArray,
  flattenedArray
} from "../../../utils/ManageArray";
import TableForm from "../../TableForm";
import ConfirmModal from "../../ConfirmModal";
import CardDisplayComponent from "../../CardDisplayComponent";
import FocService from "../../../services/foc.service";
import CustomersService from "../../../services/customer.service";
import ChildBomsService from "../../../services/childboms.service";
import ParentBomsService from "../../../services/parentboms.service";
import ContractFocHdsService from "../../../services/contractfochd.service";
import CustContractItemsService from "../../../services/custcontractitem.service";

const LumsumContractForm = ({ editData, onSubmitCallback }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [foc, setFoc] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [branches, setBranches] = useState([]);
  const [childBom, setChildBom] = useState([]);
  const [parentBom, setParentBom] = useState([]);
  const [contractFoc, setContractFoc] = useState([]);
  const [contractItem, setContractItem] = useState([]);
  const [cusData, setCusData] = useState({
    find: "",
    search: [
      { name: "Cus_Code", value: "" },
      { name: "Cus_NumBranch", value: "" },
      { name: "Cus_Name", value: "" }
    ]
  });
  const defaultData = {
    Hds: {
      Contract_Foc_Date: "",
      Contract_No: "",
      Contract_Start_Date: "",
      Contract_End_Date: "",
      Cus_Id: "",
      Cus_NumBranch: "",
      Project_No: "",
      Com_Code: user.Com_Code
    },
    Dts: {
      Contract_Foc_Hd_Id: "",
      Parent_Bom_Id: "",
      Parent_Item_Id: "",
      Child_Item_Id: "",
      Foc_Reason_Id: "",
      Foc_Reason_Name: "",
      Foc_Des: "",
      Remark: "",
      Com_Code: user.Com_Code
    }
  };
  const [data, setData] = useState({
    Hds: { Array: [defaultData.Hds] },
    Dts: { Array: [defaultData.Dts] }
  });
  const rowContract = [
    {
      name: "CustContract.Contract_Start_Date",
      label: "วันเริ่มสัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "date",
      disabled: true,
      findValue: {
        data: contractItem,
        key: "Contract_No",
        value: "Contract_No"
      }
    },
    {
      name: "CustContract.Contract_End_Date",
      label: "วันสิ้นสุดสัญญา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "date",
      disabled: true,
      findValue: {
        data: contractItem,
        key: "Contract_No",
        value: "Contract_No"
      }
    },
    {
      name: "CustContract.Project_No",
      label: "เลขที่โครงการ",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "text",
      disabled: true,
      findValue: {
        data: contractItem,
        key: "Contract_No",
        value: "Contract_No"
      }
    },
    {
      name: "Contract_Foc_Date",
      label: "วันที่",
      // classNames: { col: "mb-3", label: "mb-1" },
      type: "date",
      readOnly: true,
      disabled: !!editData
    },
    {
      name: "CustContract.Customer.Cus_Code",
      label: "รหัสลูกค้าหลัก (BP Master Code)",
      // classNames: { col: "mb-3", label: "mb-1" },
      disabled: true,
      findValue: {
        data: contractItem,
        key: "Contract_No",
        value: "Contract_No"
      }
    },
    {
      name: "CustContract.Customer.Cus_Name",
      label: "ชื่อลูกค้า",
      // classNames: { col: "mb-3", label: "mb-1" },
      type: "text",
      size: 6,
      disabled: true,
      findValue: {
        data: contractItem,
        key: "Contract_No",
        value: "Contract_No"
      }
    }
  ];
  // const rowCusNumBranch = [
  //   {
  //     name: "Cus_Code",
  //     label: "รหัสสาขา",
  //     filterBy: ["Cus_Code"],
  //     options: initializeSetOption({
  //       key: "Cus_Code",
  //       dataset: branches.filter(({ Cus_Code }) => !Cus_Code.endsWith("0000"))
  //     }),
  //     findValue: {
  //       data: branches,
  //       key: "Cus_NumBranch",
  //       value: editData?.Hds?.Cus_NumBranch
  //     }
  //   },
  //   {
  //     name: "Cus_NumBranch",
  //     label: "เลขที่สาขา",
  //     size: "1_5",
  //     filterBy: ["Cus_NumBranch"],
  //     options: initializeSetOption({
  //       key: "Cus_NumBranch",
  //       dataset: branches.filter(({ Cus_Code }) => !Cus_Code.endsWith("0000"))
  //     }),
  //     findValue: {
  //       data: branches,
  //       key: "Cus_NumBranch",
  //       value: editData?.Hds?.Cus_NumBranch
  //     }
  //   },
  //   {
  //     name: "Cus_Name",
  //     label: "ชื่อสาขา",
  //     size: null,
  //     filterBy: ["Cus_Name"],
  //     options: initializeSetOption({
  //       key: "Cus_Name",
  //       dataset: branches.filter(({ Cus_Code }) => !Cus_Code.endsWith("0000"))
  //     }),
  //     findValue: {
  //       data: branches,
  //       key: "Cus_NumBranch",
  //       value: editData?.Hds?.Cus_NumBranch
  //     }
  //   }
  // ];
  const columns = [
    {
      name: "Item.Item_Code",
      label: "รหัสสินค้า",
      type: "text",
      readOnly: true,
      findValue: {
        data: parentBom,
        key: "Item_Parent_Id",
        value: "Parent_Item_Id"
      }
    },
    {
      name: "Item.Item_Name_TH",
      label: "รายละเอียดสินค้า",
      type: "text",
      readOnly: true,
      findValue: {
        data: parentBom,
        key: "Item_Parent_Id",
        value: "Parent_Item_Id"
      }
    },
    {
      name: "Item.Item_Code",
      label: "รหัสอุปกรณ์/อะไหล่",
      type: "text",
      readOnly: true,
      findValue: {
        data: childBom,
        key: "Item_Child_Id",
        value: "Child_Item_Id"
      }
    },
    {
      name: "Item.Item_Name_TH",
      label: "ชื่ออุปกรณ์/อะไหล่",
      type: "text",
      readOnly: true,
      findValue: {
        data: childBom,
        key: "Item_Child_Id",
        value: "Child_Item_Id"
      }
    },
    {
      name: "Foc_Reason_Name",
      label: "ชื่อเหตุผลสำหรับ FOC",
      type: "select",
      noneAsync: true,
      filterBy: ["FOC_ReasonName"],
      options: initializeSetOption({ key: "FOC_ReasonName", dataset: foc })
    },
    {
      name: "FOC_Des",
      label: "รายละเอียด FOC",
      type: "text",
      readOnly: true,
      findValue: { data: foc, key: "FOC_ReasonName", value: "Foc_Reason_Name" }
    }
  ];

  const serviceRequest = (serviceRequest, setDataRequest) => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest,
      callback: (res) => setDataRequest(res?.items || res)
    });
  };

  const processContractItems = () => {
    const filteredContract = filteredItemInArray(
      contractItem,
      "Contract_No",
      data.Hds.Array[0].Contract_No
    );
    const combinedArray = filteredContract
      .map(({ Item_Id, ...item }) => ({
        ...item,
        Parent_Bom_Id: findItemInArray(parentBom, "Item_Parent_Id", Item_Id)?.Id
      }))
      .map(({ Parent_Bom_Id, ...parent }) => ({
        ...parent,
        Parent_Bom_Id,
        Child_Bom: filteredItemInArray(childBom, "Parent_Bom_Id", Parent_Bom_Id)
      }));

    return flattenedArray(combinedArray, "Child_Bom");
  };

  const handleChange = (name, value) => {
    const {
      Contract_Start_Date,
      Contract_End_Date,
      Cus_Id,
      Project_No,
      Customer
    } =
      name === "Contract_No"
        ? findItemInArray(contractItem, name, value)?.CustContract
        : "";
    const { Cus_NumBranch } =
      name !== "Contract_No" ? findItemInArray(customer, name, value) : "";

    setData((prev) => ({
      ...prev,
      Hds: {
        Array: [
          {
            ...data.Hds.Array[0],
            ...(name === "Contract_No" && value
              ? {
                  [name]: value,
                  Contract_Start_Date: formatInputDate(
                    Contract_Start_Date,
                    "Local"
                  ).date,
                  Contract_End_Date: formatInputDate(Contract_End_Date, "Local")
                    .date,
                  Contract_Foc_Date: formatInputDate(new Date(), "Local").date,
                  Project_No,
                  Cus_Id
                }
              : {}),
            ...(name !== "Contract_No" ? { Cus_NumBranch } : {})
          },
          ...data.Hds.Array.slice(1)
        ]
      }
    }));

    setCusData((prev) => ({
      ...prev,
      ...(name === "Contract_No"
        ? { find: Customer?.Cus_Code }
        : {
            search: cusData.search.map((item) =>
              item.name === name ? { ...item, value } : item
            )
          })
    }));
    if (Customer?.Cus_Code.endsWith("0000")) {
      serviceRequest(
        CustomersService.getCustomerBranches(Customer?.Id),
        setBranches
      );
    }
  };

  const checkValidity = () => {
    if (data.Dts.Array.find(({ Parent_Bom_Id }) => Parent_Bom_Id === "")) {
      showAlert({
        error: "ข้อผิดพลาด",
        message: `กรุณาสร้าง Bom ของรหัสสินค้าที่ยังไม่สร้างก่อน`,
        type: "danger"
      });
      return false;
    }
    const passEmptyHds = ["Cus_NumBranch"];
    const passEmptyDts = ["Contract_Foc_Hd_Id", "Remark"];
    if (
      emptyValueObjects(data.Hds.Array, passEmptyHds)?.length ||
      emptyValueObjects(data.Dts.Array, passEmptyDts)?.length
    ) {
      showAlert({
        error: "ข้อผิดพลาด",
        message: "กรุณากรอกข้อมูลให้ครบถ้วน",
        type: "danger"
      });
      return false;
    }
    return true;
  };

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity() || !checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal(true);
    }
  };

  const handleSubmit = (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);

    if (dataCallback) {
      if (!editData) onSubmitCallback(dataCallback);
      else onSubmitCallback(dataCallback.Dts.Array[0]);
    }
  };

  useEffect(() => {
    if (!editData && data.Hds.Array[0].Contract_No) {
      const resultArray = processContractItems();

      setData((prev) => ({
        ...prev,
        Dts: {
          ...prev.Dts,
          Array: resultArray?.length
            ? resultArray.map(({ Parent_Bom_Id, Child_Bom, Item }) => ({
                ...defaultData.Dts,
                Parent_Bom_Id: Parent_Bom_Id || "",
                Parent_Item_Id: Item.Id || "",
                Child_Item_Id: Child_Bom.Item_Child_Id || ""
              }))
            : [defaultData.Dts]
        }
      }));
    }
  }, [data.Hds?.Array?.[0].Contract_No]);

  useEffect(() => {
    serviceRequest(
      ContractFocHdsService.getAllContractFocHds(),
      setContractFoc
    );
    serviceRequest(CustomersService.getAllCustomers(), setCustomer);
    serviceRequest(ParentBomsService.getAllParentBoms(), setParentBom);
    serviceRequest(ChildBomsService.getAllChildBoms(), setChildBom);
    serviceRequest(FocService.getAllFocs(), setFoc);

    if (editData?.Hds && editData?.Dts) {
      setData((prev) => ({
        ...prev,
        Hds: {
          Array: [
            {
              Contract_Foc_Date: editData?.Hds?.Contract_Foc_Date,
              Contract_No: editData?.Hds?.Contract_No,
              Contract_Start_Date: editData?.Hds?.Contract_Start_Date,
              Contract_End_Date: editData?.Hds?.Contract_End_Date,
              Cus_Id: editData?.Hds?.Cus_Id,
              Cus_NumBranch: editData?.Hds?.Cus_NumBranch,
              Project_No: editData?.Hds?.Project_No,
              Com_Code: editData?.Hds?.Com_Code
            }
          ]
        },
        Dts: {
          Array: [
            {
              Contract_Foc_Hd_Id: editData?.Dts?.Contract_Foc_Hd_Id,
              Parent_Bom_Id: editData?.Dts?.Parent_Bom_Id,
              Parent_Item_Id: editData?.Dts?.Parent_Item_Id,
              Child_Item_Id: editData?.Dts?.Child_Item_Id,
              Foc_Reason_Id: editData?.Dts?.Foc_Reason_Id,
              Foc_Reason_Name: editData?.Dts?.Foc_Reason_Name,
              Foc_Des: editData?.Dts?.Foc_Des,
              Remark: editData?.Dts?.Remark,
              Com_Code: editData?.Dts?.Com_Code
            }
          ]
        }
      }));

      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: CustContractItemsService.getAllCustContractItems(
          `?keyword=${editData?.Hds?.Contract_No}`
        ),
        callback: ({ items }) => setContractItem(items)
      });

      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: CustomersService.getCustomerBranches(
          editData?.Hds?.Cus_Id
        ),
        callback: (items) => setBranches(items)
      });
    }
  }, [editData]);

  return (
    <Form noValidate validated={validated} onSubmit={handleValidated}>
      <CardDisplayComponent
        body={{
          as: Row,
          element: (
            <>
              <Col sm={3} className="mb-3">
                <SearchSelectComponent
                  labelField="เลขที่สัญญา"
                  floatingClass="mb-1"
                  placeholder="โปรดเลือก"
                  disabled={editData ? true : false}
                  isInvalid={data.Hds.Array?.[0]?.Contract_No === ""}
                  options={initializeSetOptionDisabled(
                    { key: "Contract_No", dataset: contractItem },
                    { key: "Contract_No", data: contractFoc }
                  )}
                  queryService={(query) =>
                    getServiceRequest({
                      showAlert,
                      setLoading,
                      serviceRequest:
                        CustContractItemsService.getAllCustContractItems(query),
                      callback: ({ items }) => setContractItem(items)
                    })
                  }
                  onChange={(change) =>
                    handleChange("Contract_No", change?.value)
                  }
                  value={data.Hds.Array?.[0]?.Contract_No}
                />
              </Col>

              {rowContract.map(
                ({
                  name,
                  label,
                  classNames,
                  type,
                  size,
                  findValue,
                  readOnly,
                  disabled
                }) => (
                  <Col key={name} sm={size || 3} className={classNames?.col}>
                    <FloatingControlComponent
                      type={type}
                      name={name}
                      label={label}
                      readOnly={readOnly}
                      disabled={disabled}
                      className={classNames}
                      placeholder="โปรดระบุ"
                      value={
                        autoDisplayValue({
                          name,
                          type,
                          findValue: {
                            ...findValue,
                            value: data.Hds.Array?.[0]?.[findValue?.value]
                          }
                        }) || data.Hds.Array?.[0]?.[name]
                      }
                    />
                  </Col>
                )
              )}

              {/* {rowCusNumBranch.map(
                ({
                  name,
                  label,
                  classNames,
                  options,
                  queryService,
                  size,
                  filterBy
                }) => (
                  <Col
                    key={name}
                    sm={size === null ? null : size || 3}
                    className={classNames?.col}
                  >
                    <SearchSelectComponent
                      labelField={label}
                      placeholder="โปรดเลือก"
                      options={options}
                      filterBy={filterBy}
                      queryService={queryService}
                      disabled={editData ? true : false}
                      onChange={(change) =>
                        handleChange(name, change?.value || null)
                      }
                      value={
                        findItemInArray(cusData?.search, "name", name)?.value
                      }
                    />
                  </Col>
                )
              )} */}
            </>
          )
        }}
      />

      <CardDisplayComponent
        header={{
          title: {
            text: !editData ? "เพิ่มข้อมูล FOC ในสัญญา LUMSUM" : "รายการแก้ไข"
          }
        }}
        body={{
          element: (
            <TableForm
              editForm
              data={data.Dts.Array}
              columns={columns}
              defaultData={defaultData}
              onChangeCallback={(newData) =>
                setData((prev) => ({
                  ...prev,
                  Dts: {
                    Array: newData.map((item) => {
                      const findFOC = findItemInArray(
                        foc,
                        "FOC_ReasonName",
                        item.Foc_Reason_Name
                      );
                      return {
                        ...item,
                        Foc_Reason_Id: findFOC?.Id,
                        Foc_Des: findFOC?.FOC_Des
                      };
                    })
                  }
                }))
              }
            />
          )
        }}
        footer={{
          className: "text-end",
          element: (
            <>
              <Button
                type="submit"
                variant="success"
                className="me-2 px-5 py-2 text-dark rounded-pill"
              >
                {editData ? "บันทึกการแก้ไข" : "บันทึกข้อมูล"}
              </Button>
              <ConfirmModal
                show={showModal}
                data={data}
                content={editData ? "edit" : "save"}
                onSubmitCallback={handleSubmit}
              />

              <Button
                variant="outline-success"
                className="px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
                onClick={() =>
                  navigate("/MA_service", { state: { name: "lumsum" } })
                }
              >
                ยกเลิก
              </Button>
            </>
          )
        }}
      />
    </Form>
  );
};

LumsumContractForm.propTypes = {
  editData: PropTypes.object,
  onSubmitCallback: PropTypes.func
};

export default LumsumContractForm;
